import { NameableEntity } from 'modules/shared/models';
import { Image } from '../image';
import { LightProduct } from './light-product';
import { Brand } from '../brand';
import { CatalogueElement } from '..';

export interface Variant {
    id: string;
    name: string;
    price: number;
}

export interface SelectableVariant extends Variant {
    quantity: number;
}

export interface Product extends NameableEntity<number>, CatalogueElement {
    specs: string;
    brand: Brand;
    price: number;
    images: Image[];
    collections: LightProduct[];
    favorites: LightProduct[];
    variants?: Variant[];
    category?: NameableEntity<number>;
    parentCategory?: NameableEntity<number>;
    universe: NameableEntity<number>;
    availability?: Availability;
}

/* Availability */
export type Availability = 0 | 1 | 2 | 3 | 4 | 5;
const UNKNOWN_AVAILABILITY: Availability = 0;
const HAUSSMAN_WITH_ORDER: Availability = 1;
const OTHER_WITH_ORDER: Availability = 2;
const HAUSSMAN_WITHOUT_ORDER: Availability = 3;
const OTHER_WITHOUT_ORDER: Availability = 4;
const MID: Availability = 5;

export const AvailabilityValues = {
    UNKNOWN: UNKNOWN_AVAILABILITY,
    HAUSSMAN_WITH_ORDER,
    OTHER_WITH_ORDER,
    HAUSSMAN_WITHOUT_ORDER,
    OTHER_WITHOUT_ORDER,
    MID,
};
